<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="调整任务位置"
        width="600px"
        append-to-body
        top="10vh"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" class="pr50">
                <el-form-item label="任务名称：">
                    <p class="mt2">{{data.task_name}}（{{data.task_number}}）</p>
                </el-form-item>
                <el-form-item label="当前位置：">
                    <p class="mt2">{{data.current_pos}}</p>
                </el-form-item>
                <el-form-item label="新排序位置：" prop="pos">
                    <el-input-number
                        v-model="formItem.pos"
                        :max="100000"
                        :precision="0"
                        :controls="false"
                        label="当输入的值超出任务数量，则排至最后"
                        style="width:250px;"
                    ></el-input-number>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/efficiencyTool/task.js';

    export default {
        name: "PositionModal",
        props:{
            data:Object,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    pos:undefined,
                },
                submitLoading:false,
                rules:{
                    pos:[
                        { required: true, message: '请输入新排序位置', trigger: 'blur' },
                        { type: 'number', min:1,message: '请输入数值', trigger: 'blur' },
                    ],
                },
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                console.log('resetForm');
                this.formItem.pos= undefined;
                this.$refs.form.resetFields();
            },
            showModal(){
                this.dialogVisible = true;
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                       API.setTaskPos({
                           current_pos:this.data.current_pos,
                           pos:this.formItem.pos,
                           task_id:this.data.task_id,
                       }).then(res=>{
                           this.submitLoading = false;
                           this.$message.success(res.info||'操作成功');
                           this.handleClose();
                           this.$emit('update');
                       },err=>{
                           console.log('setTaskPos err',err);
                           this.submitLoading = false;
                           this.$message.error(err.info||'操作失败');
                       });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
    }
</style>
